import React, { useState, useEffect } from 'react';
import { Row } from 'react-bootstrap';
import HVASystemKPICard1 from 'components/cards/HVASystemKPICard1';
import HVASystemKPICard2 from 'components/cards/HVASystemKPICard2';
import {
  fetchHVACallingTodayKPIs,
  FetchHVACallingTodayKPIsParams
} from 'services/hvacallingmanagment.service';
import {
  faPeopleGroup,
  faComments,
  faArrowsDownToPeople,
  faPeopleArrows,
  faVolumeControlPhone
} from '@fortawesome/free-solid-svg-icons';

// Definir la estructura de los KPIs
interface HVACallingKPIs {
  actualcalls: number;
  clients: number;
  clientnumbers: number;
  dialed: number;
  dialednumbers: number;
  answer: number;
  answernumbers: number;
  talktime: number;
}

// Props del componente con un parámetro opcional campaignid
interface ActualCallingKPIsProps {
  campaignid?: number;
}

const ActualCallingKPIs: React.FC<ActualCallingKPIsProps> = ({
  campaignid
}) => {
  // Estado para almacenar los KPIs
  const [kpis, setKpis] = useState<HVACallingKPIs>({
    actualcalls: 0,
    clients: 0,
    clientnumbers: 0,
    dialed: 0,
    dialednumbers: 0,
    answer: 0,
    answernumbers: 0,
    talktime: 0
  });

  useEffect(() => {
    // Función para obtener los KPIs de hoy
    const getKPIs = async () => {
      try {
        const params: FetchHVACallingTodayKPIsParams = { campaign: campaignid };
        const response = await fetchHVACallingTodayKPIs(params);
        setKpis(response);
      } catch (error) {
        console.error('Error fetching KPIs:', error);
      }
    };

    // Llamada a la función al montar el componente y luego cada 5 segundos
    getKPIs();
    const intervalId = setInterval(getKPIs, 5000);

    // Limpiar el intervalo cuando el componente se desmonta
    return () => clearInterval(intervalId);
  }, [campaignid]);

  // Verificación de divisiones por cero
  // eslint-disable-next-line
  const safeDivide = (numerator: number, denominator: number) => (denominator !== 0 ? numerator / denominator : 0);

  return (
    <>
      <Row className="align-items-center mb-1 align-content-between">
        <HVASystemKPICard1
          icon={faVolumeControlPhone}
          color="white"
          label="Actual calls"
          value={kpis.actualcalls}
          value2={
            kpis.dialed > 0 ? safeDivide(kpis.answer, kpis.dialed) * 100 : 0
          } // Evita división por 0
          value3={
            kpis.answer > 0 ? safeDivide(kpis.talktime / 60, kpis.answer) : 0
          } // Evita división por 0; talktime está en segundos y se convierte a minutos
          title="Dialing"
        />
      </Row>
      <Row className="align-items-center mb-1 align-content-between">
        <HVASystemKPICard2
          icon={faPeopleGroup}
          color="primary-dark"
          label="Today"
          value={kpis.clients}
          value2={kpis.clientnumbers}
          title="Clients"
        />
      </Row>
      <Row className="align-items-center mb-1 align-content-between">
        <HVASystemKPICard2
          icon={faArrowsDownToPeople}
          color="primary-dark"
          label="Today"
          value={kpis.dialed}
          value2={kpis.dialednumbers}
          title="Dialed"
        />
      </Row>
      <Row className="align-items-center mb-1 align-content-between">
        <HVASystemKPICard2
          icon={faPeopleArrows}
          color="primary-dark"
          label="Today"
          value={kpis.answer}
          value2={kpis.answernumbers}
          title="Answer"
        />
      </Row>
      <Row className="align-items-center mb-0 align-content-between">
        <HVASystemKPICard2
          icon={faComments}
          color="primary-dark"
          label="Today"
          value={kpis.talktime / 3600} // talktime está en segundos y se convierte a horas
          title="Talk time"
        />
      </Row>
    </>
  );
};

export default ActualCallingKPIs;
